import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-ink text-white" data-id="element-0" data-mp="31bs1ff0jszn8">
      <MetaPixel data-id="element-1" data-mp="2wjgqzi86lvgf" />
      <main data-id="element-2" data-mp="2wiyy8vkq9zd9">
        <Hero data-id="element-3" data-mp="2wj8f9tnsow6t" />
        <Stats data-id="element-4" data-mp="2wip54z4dzc3c" />
        <Testimonials data-id="element-5" data-mp="2wi5mthatqlos" />
        <PainPoints data-id="element-6" data-mp="28u5ysp4wd9dw" />
        <Tomos data-id="element-7" data-mp="28tmifcuwat1z" />
        <Bonuses data-id="element-8" data-mp="28t4k8aooa4rf" />
        <Countdown data-id="element-9" data-mp="28sl5t3y8dyi5" />
        <Pricing data-id="element-10" data-mp="28s31dk1f0dz5" />
        <FAQ data-id="element-11" data-mp="23vkzcrxgytqi" />
        <Countdown data-id="element-12" data-mp="23w4drynwuzzs" />
        <ValueStack data-id="element-13" data-mp="23ujl6el5pr4k" />
      </main>
      <Footer data-id="element-14" data-mp="23ti864kkyuk7" />
    </div>;
}